<template>
  <div>
    <Analytics />
    <SpeedInsights />
    <NuxtLayout>
      <NuxtPage />
    </NuxtLayout>
    <EventDetailPanel />
    <AppNotifications />
    <ClientOnly>
      <CookieBanner />
    </ClientOnly>
  </div>
</template>

<script setup lang="ts">
import '@/assets/css/tailwind.css';
import { Analytics } from '@vercel/analytics/nuxt';
import { SpeedInsights } from '@vercel/speed-insights/nuxt';

const { load: initGa } = useScriptGoogleAnalytics({
  scriptOptions: { trigger: 'manual' },
});
const { accepted } = useCookieConsent();

if (import.meta.client) {
  watch(
    accepted,
    (val) => {
      if (val) initGa();
    },
    { immediate: true },
  );
}
</script>
